import { useIntl } from "react-intl";
import BaseButton from "components/common/BaseButton";

interface Props {
  errorMessage: string | null;
  onRetry: () => void;
}

const ErrorPage = ({ errorMessage, onRetry }: Props) => {
  const intl = useIntl();
  return (
    <div className="usadmin-error-page">
      <h1>
        {errorMessage || intl.formatMessage({ id: "usAdmin.fetchError" })}
      </h1>
      <BaseButton
        handleSubmit={onRetry}
        text={intl.formatMessage({ id: "retry" })}
      />
    </div>
  );
};

export default ErrorPage;
